import React from 'react';

export const DownloadIcon = ({
  className = '',
  color = 'currentColor',
  height = '24',
  width = '24',
}) => (
  <svg
    className={className}
    height={height}
    width={width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 15C20.5523 15 21 15.4477 21 16V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V18.5C5 18.7761 5.22386 19 5.5 19H18.5C18.7761 19 19 18.7761 19 18.5V16C19 15.4477 19.4477 15 20 15ZM11.293 16.707L7 12.414C6.62103 12.0216 6.62645 11.3979 7.01218 11.0122C7.39792 10.6264 8.02162 10.621 8.414 11L11 13.586V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V13.586L15.586 11C15.9784 10.621 16.6021 10.6264 16.9878 11.0122C17.3736 11.3979 17.379 12.0216 17 12.414L12.707 16.707C12.3165 17.0974 11.6835 17.0974 11.293 16.707Z"
      fill={color}
    />
  </svg>
);
